'use client'

import { createAuthClient } from 'better-auth/react'
import { emailOTPClient, magicLinkClient, phoneNumberClient } from 'better-auth/client/plugins'

export const authClient = createAuthClient({
  baseURL: process.env.NEXT_PUBLIC_APP_URL ?? 'http://localhost:3098',
  plugins: [emailOTPClient(), magicLinkClient(), phoneNumberClient()],
})

export const { signIn, signOut, useSession, updateUser } = authClient
